import React from "react";
import { Slideshow } from "../base/Slideshow";
import { FILM_CONFIG } from "./filmConfig";

export default function FilmSlideshow() {
  return (
    <Slideshow
      config={{
        title: FILM_CONFIG.slideshow.title,
        heading: FILM_CONFIG.heading,
        subtitle: FILM_CONFIG.subtitle,
        brand: FILM_CONFIG.brand,
      }}
    />
  );
}
